export default "__VITE_ASSET__DqEcz7w7__"